// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".frame-layout{width:100%;height:100%;position:absolute;overflow:hidden}.frame-layout .frame-system{height:calc(100% - 50px)}", ""]);
// Exports
module.exports = exports;
